import '/assets/js/property.min';

export default function IndexScripts () {
  return (
    <>
      {/*<Script type="module" src="/assets/plugins/jquery/v3.6.0/jquery.min.js"/>*/}
      {/*<Script type="module" src="/assets/plugins/lazyload/lazyload.min.js"/>*/}
      {/*<Script type="module" src="/javascripts/loader.min.js"/>*/}
      {/*<Script type="module" src="/assets/plugins/bootstrap-5.1.3/dist/js/bootstrap.min.js"/>*/}
      {/*<Script type="module" src="/assets/pages/js/pages.min.js"/>*/}
      {/*<Script type="module" src="/assets/pages/frontend/pages.frontend.min.js"/>*/}
      {/*<Script type="module" src="/assets/js/builder.min.js"/>*/}
    </>
  )
}
